import Link from "next/link";
import type { PropsWithChildren } from "react";

type ConditionalLinkProps = PropsWithChildren<{
  condition: boolean;
  href: string | null;
  ariaLabel?: string;
  onClick?: () => void;
}>;

function ConditionalLink({
  condition,
  href,
  ariaLabel,
  children,
  onClick,
}: ConditionalLinkProps) {
  if (!condition || !href) {
    return <>{children}</>;
  }

  return (
    <Link href={href} prefetch={false} aria-label={ariaLabel} onClick={onClick}>
      {children}
    </Link>
  );
}

export { ConditionalLink };
